import mapSeries from 'async/mapSeries';
import Cookies from 'js-cookie';

// import * as api from '@/api';
import * as types from '@/store/mutation-types';
import { healthSign } from '@/store/action.util';
import reportLog from '../../comm/middleware/reportLog';
import { getApi } from '../../comm/middleware/callApi';
import apis from '../../comm/api/apis';
import { updateAjaxHeaderConfig } from '../../comm/api';
import auth from '../../lib/auth';

export * from './expertAnswer/actions.expertAnswer';

// 专家授权
export const expertAuth = (store, { accessToken = null, expertInfo = null, successFn = () => {} }) => {
  if (accessToken) {
    getApi({ commit: store.commit }, apis.expertAuth, { accessToken }).then((info) => {
      updateAjaxHeaderConfig({ token: info.token });
      Cookies.set('expertInfo', info); // FIXME: 测试代码，需删除
      store.commit(types.AJAX_GET_EXPERTAUTH, {
        info
      });
      healthSign(store, {});
      successFn();
    }).catch((e) => {
      const msg = {
        name: '专家授权失败',
        protocol: document.location.protocol === 'https:' ? 'https' : 'http',
        info: e,
        time: Date.parse(new Date())
      };

      // 签名成功，发送日志
      reportLog(msg).then(() => {
        console.log('日志-专家授权失败');
      });
    });
  } else if (expertInfo) {
    updateAjaxHeaderConfig({ token: expertInfo.token });
    store.commit(types.AJAX_GET_EXPERTAUTH, {
      info: expertInfo
    });
    healthSign(store, {});
  }
};

// 专家开讲
export const getCourseList = ({ commit }, { status = [0, 1], pageNo = 1, pageSize = 20 }) => {
  getApi({ commit }, apis.courseList, { startstatus: JSON.stringify(status), pageNo, pageSize }).then((body) => {
    const courseList = body.data;
    commit(types.AJAX_GET_COURSELIST, {
      courseList,
      pageNo
    });
  });
};

// 专家图片列表
export const getPictureList = ({ commit, state }, { lastId, type = 0, source = 1, courseId = state.courseInfo.id, pagesize = 20, naxtPage }) => {
  getApi({ commit }, apis.pictureList, { lastid: lastId, type, source, courseid: courseId, pagesize }).then((body) => {
    const pictureList = body.data.list;
    const hasPictures = body.data.hasNextPage;
    commit(types.AJAX_GET_MATERIAL_PICTURELIST, {
      pictureList,
      naxtPage,
      hasPictures
    });
  });
};
// 素材库PPT图片列表
export const getMaterialPPTList = ({ commit, state }, { lastId, type = 0, source = 0, courseId = state.courseInfo.id, pagesize = 20, naxtPage }) => {
  getApi({ commit }, apis.pictureList, { lastid: lastId, type, source, courseid: courseId, pagesize }).then((body) => {
    const PPTList = body.data.list;
    const hasPPTs = body.data.hasNextPage;
    commit(types.AJAX_GET_MATERIAL_PPTLIST, {
      PPTList,
      naxtPage,
      hasPPTs
    });
  });
};

// 专家图片列表排序
export const movePictureList = ({ commit }, { materialid, replaceid }) => {
  getApi({ commit }, apis.movePicture, { materialid, replaceid }).then(() => {
    console.info('排序成功');
  });
};

// 专家素材库音频列表
export const getAudioList = ({ commit }, { lastId, type = 1, source = 1, courseId, pagesize = 20, naxtPage }) => {
  getApi({ commit }, apis.pictureList, { lastid: lastId, type, source, courseid: courseId, pagesize }).then((body) => {
    const audioList = body.data.list;
    const hasNextPage = body.data.hasNextPage;
    commit(types.AJAX_GET_MATERIAL_AUDIOLIST, {
      audioList,
      naxtPage,
      hasNextPage
    });
  });
};

// 专家素材库音频列表
export const getVideoList = ({ commit }, { lastId, type = 2, source = 1, courseId, pagesize = 20, naxtPage }) => {
  getApi({ commit }, apis.pictureList, { lastid: lastId, type, source, courseid: courseId, pagesize }).then((body) => {
    const videoList = body.data.list;
    const hasNextPage = body.data.hasNextPage;
    commit(types.AJAX_GET_MATERIAL_VIDEOLIST, {
      videoList,
      naxtPage,
      hasNextPage
    });
  });
};

// 专家素材库清空
export const clearMateriallist = ({ commit, state }) => {
  commit(types.CLEAR_MATERIALLIST_LOCAL, state);
};

/**
 * 批量删除图片
 * @param  {[type]} options.store [description]
 * @param  {[type]} payload        [description]
 * @param  {[type]} payload.pictureList        图片素材的 id 数组
 * @return {[type]}                [description]
 */
export const deletePicture = ({ commit, state }, { token = state.expertInfo.token, pictureList, pictureIds }) => {
  getApi({ commit }, apis.deletePicture, { token, materialidlist: pictureList }).then(() => {
    commit(types.DELETEIMAGEONLOCAL, { imageIds: pictureIds });
  });
};

/**
 * 开始录音
 */
const F_TIME = 200;

let isStartRecord = false;
let sTime;
export const startRecord = (store) => {
  window.wx.startRecord({
    success() {
      console.log(`cost time ===> ${new Date() - sTime}`);
      store.commit(types.AJAX_WX_STARTRECORD);
      isStartRecord = true;
    },
    fail() {
      /* eslint-disable */
      const expertInfo = Cookies.get('expertInfo');
      const msg = `[WX_JSSDK_ERROR] [expertInfo:${expertInfo}][ua:${navigator.userAgent}]startRecord fail...isDoing:${stopRecord.isDoing}...isStartRecord:${isStartRecord}...wxSignStatus:${store.state.wxSignStatus}`;
      // 录音出错 出错，发送日志
      reportLog(msg).then(() => {
        console.log('发送日志成功', msg);
      });
        stopRecord.isDoing = false;
        window.wx.stopRecord({
          success() {
            console.log('startRecord re try');
            startRecord(store);
          },
          fail() {
            console.log('record is stop');
            startRecord(store);
          },
        });
        isStartRecord = false;
      /* esint-enable */
    },
  });
};

/**
 * 插入信息，乐观UI
 * @param  {[type]} store        [description]
 * @param  {[type]} audioMessage  音频信息
 */
export const insertAudio = (store, audioMessage) => {
  store.commit(types.SOCKET_RECEIVE_MESSAGE, { messages: [audioMessage] });
};

/**
 * 控制频次
 * @param  {[type]} fun  需要控制的函数
 * @param  {[type]} time 频次
 */
let frequencyTime;
function controlFrequency(fun, time) {
  return (...args) => {
    console.log(`controlFrequency ===> ${fun.isDoing} , ${isStartRecord}`);
    if (!fun.isDoing && isStartRecord) {
      fun.apply(this, args);
      fun.isDoing = true;
      console.log('stopRecord start');

      clearTimeout(frequencyTime);
      const over = () => {
        console.log('stopRecord end');
        fun.isDoing = false;
        clearTimeout(frequencyTime);
        frequencyTime = null;
      };

      frequencyTime = setTimeout(over, time);
    }
  };
}

/**
 * 关闭录音，不能连续调用两次，否则会导致fail
 * @param  {[type]} store              [description]
 * @param  {[type]} options.isContinue  是否分段发送
 * @param  {[type]} options.time       重试次数
 * @param  {[type]} options.flag       关闭不上传
 */
const stopRecord = (store, { isContinue, time = 2, flag } = {}) => {
  console.log('stopRecord ing...');
  const stopRecordTime = new Date();
  if (stopRecord.isDoing) {
    console.log('stopRecord is doing');
    return;
  }

  // startRecordTime 证明已经结束
  if (!store.state.startRecordTime) {
    console.log('startRecordTime is null');
    clearTimeout(frequencyTime);
    stopRecord.isDoing = false;
    return;
  }

  console.log('window.wx.stopRecord start');
  window.wx.stopRecord({
    success: (res) => {
      console.log('stopRecord success');
      sTime = new Date();
      clearTimeout(frequencyTime);
      isStartRecord = false;
      stopRecord.isDoing = false;

      if (flag) {
        return;
      }

      // 毫秒转成秒
      const speech = Math.ceil((stopRecordTime - store.state.startRecordTime) / 1000);
      const localId = res.localId;

      // 这个时候只是缓存音频信息
      if (isContinue) {
        // 防止播放状态
        store.commit(types.AJAX_WX_STOPRECORD, {
          localId,
        });
        startRecord(store);
      }
      store.commit(types.AJAX_WX_UPLOADRECORD);
      window.wx.uploadVoice({
        localId, // 需要上传的音频的本地ID，由stopRecord接口获得
        isShowProgressTips: isContinue ? 0 : 1, // 默认为1，显示进度提示, 0 不提示
        success: (uploadRes) => {
          const serverId = uploadRes.serverId; // 返回音频的服务器端ID
          const audio = {
            localId,
            mediaId: serverId,
            speech,
            isUpload: false,
          };
          console.log(`upload audio----------- ===> ${JSON.stringify(audio)}`);
          // 有顺序问题
          if (isContinue) {
            store.commit(types.AJAX_WX_UPDATERECORD, audio);
          } else {
            store.commit(types.AJAX_WX_STOPRECORD, audio);
          }
        },
        fail: (res) => {
          const expertInfo = Cookies.get('expertInfo');
          const msg = `[WX_JSSDK_ERROR] [expertInfo:${expertInfo}][ua:${navigator.userAgent}] upload error...${JSON.stringify(res)}`;
          // 停止录音出错 出错，发送日志
          reportLog(msg).then(() => {
            console.log('发送日志成功', msg);
          });
        },
      });
    },
    fail: (res) => {
      /* eslint-disable */
      const expertInfo = Cookies.get('expertInfo');
      const msg = `[WX_JSSDK_ERROR] [expertInfo:${expertInfo}][ua:${navigator.userAgent}] stopRecord error...isDoing:${stopRecord.isDoing} ...isStartRecord:${isStartRecord}...time:${time}...isContinue:${isContinue}`;
      // 停止录音出错 出错，发送日志
      reportLog(msg).then(() => {
        console.log('发送日志成功', msg);
      });


      let delayTime = setTimeout(() => {
        stopRecord.isDoing = false;
        clearTimeout(frequencyTime);
        frequencyTime = null;
        if (time === 0) {
          store.commit(types.AJAX_ERROR, new Error(res.errMsg));
        } else {
          time -= 1;
          stopRecord(store, { isContinue, time });
        }
        clearTimeout(delayTime);
        delayTime = null;
      }, F_TIME * 5);
      /* esint-enable */
    },
  });
  console.log('window.wx.stopRecord end');
};

/**
 * stopRecord 控制F_TIME频率执行一次，期间执行会被抛弃掉
 * @type {[type]}
 */
export const stopRecordControl = controlFrequency(stopRecord, F_TIME * 3);


// 重录录音
export const reRecord = (store) => {
  store.commit(types.AJAX_WX_RERECORD);
};

/**
 * 上传图片
 * @param  {[type]} store [description]
 * @param  {String} options.action 选择图片的行为 默认为 sendMessage 发送消息， uploadImage 上传图片
 * @return {[type]}       [description]
 */
export const uploadImage = (store, { imageLocalIds, action = 'sendMessage' }) => {
  const commit = store.commit;
  const state = store.state;
  commit(types.AJAX_LOADING, { loadingStatus: true });
  mapSeries(imageLocalIds, (imageLocalId, callback) => {
    console.log(imageLocalId);
    window.wx.uploadImage({
      localId: imageLocalId, // 需要上传的图片的本地ID，由chooseImage接口获得
      isShowProgressTips: 1, // 默认为1，显示进度提示
      success: (res) => {
        const serverId = res.serverId; // 返回图片的服务器端ID
        callback(null, serverId);
      },
      fail: (res) => {
        commit(types.AJAX_ERROR, new Error(res.errMsg));
      },
    });
  }, (err, imageServerIds) => {
    commit(types.AJAX_LOADING, { loadingStatus: false });
    if (!err) {
      if (action === 'sendMessage') {
        commit(types.AJAX_WX_CHOOSESENDIMAGE, { imageServerIds });
      } else if (action === 'uploadImage') {
        getApi({ commit }, apis.uploadImage, { mediaIdList: JSON.stringify(imageServerIds), type: 0, courseId: state.courseInfo.id }).then(() => {
          getPictureList(store, {});
        });
        // commit(types.AJAX_WX_UPLOADIMAGE, { imageServerIds });
      }
    } else {
      commit(types.AJAX_ERROR, err);
    }
  });
};

/**
 * 选择图片
 * @param  {[type]} store          [description]
 * @param  {String} options.action 选择图片的行为 默认为 sendMessage 发送消息， uploadImage 上传图片
 * @return {[type]}                [description]
 */
export const chooseImage = (store, { action = 'sendMessage' }) => {
  window.wx.chooseImage({
    count: 9, // 默认9
    sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
    sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
    success: (res) => {
      const imageLocalIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
      uploadImage(store, { imageLocalIds, action });
    },
    fail: (res) => {
      store.commit(types.AJAX_ERROR, new Error(res.errMsg));
    },
  });
};

/**
 * 回复消息
 * @param  {[type]} store   [description]
 * @param  {[type]} payload [description]
 * @return {[type]}         [description]
 */
export const replyMessage = (store, payload) => {
  store.commit(types.COMPONENTS_CURRENTMESSAGE, {
    replyMessage: payload.replyMessage,
  });
};

/**
 * 直播间popup窗体状态
 * @param  {[type]} store   [description]
 * @param  {[type]} payload [description]
 * @return {[type]}         [description]
 */
export const livePopupVisible = (store, payload) => {
  store.commit(types.COMPONENTS_POPUPVISIBLE, {
    livePopupVisible: payload,
  });
};

/**
 * 直播间Tab选项卡状态
 * @param  {[type]} store   [description]
 * @param  {[type]} payload [description]
 * @return {[type]}         [description]
 */
export const liveBarActive = (store, payload) => {
  store.commit(types.COMPONENTS_LIVEBARACTIVE, {
    isActive: payload,
  });
};

// 获取问题列表
export const getIssues = ({ commit }, { courseId, condition, direction, isFilter, lastId }) => {
  getApi({ commit }, apis.issues, { courseId, condition, direction, ishideanswered: isFilter, lastId}).then((body) => {
    const issues = body.data;
    commit(types.AJAX_GET_ISSUES, {
      issues,
      lastId,
    });
  });
};

// 获取专家端幻灯片
export const getSlidesList = ({ commit }, { courseId, width, height }) => {
  getApi({ commit }, apis.expertSlides, { courseid: courseId, width, height}).then((body) => {
    const slides = body.data;
    commit(types.AJAX_GET_SLIDES, {
      slides,
    });
  }).catch((e) => {
    if ( e.rtn_code === '0000002') {
      auth.clear();
      auth.login('expert', null);
    }
  });
};

// 专家子课程列表
export const getCourseMsgList = ({ commit }, { curpage = 1, pagesize = 20 }) => {
  getApi({ commit }, apis.expertCourseList, { curpage, pagesize }).then((body) => {
    const courseMsgList = body.data;
    commit(types.AJAX_GET_COURSE_MSG_LIST, courseMsgList);
  });
};

// 专家子课程留言列表
export const getCourseGuestbook = ({ commit, state }, { curpage = 1, pagesize = 20, id, type }) => {
  const protocol = location.protocol.replace(':', '');
  getApi({ commit }, apis.messageList, { curpage, pagesize, id, protocol, type }).then((body) => {
    const GuestbookList = body.data;
    commit(types.AJAX_GET_GUESTBOOK_LIST, GuestbookList);
  });
};

// 专家端删除留言回复
export const delMsgReply = ({ commit }, { replyid }) => {
  return getApi({ commit }, apis.delMsgReply, { replyid })
    .then((body) => {
      commit(types.DEL_REPLY_TO_LIST, {id:  replyid});
    //   return body.data;
    });
};
// 专家端回复留言
export const replyMsg = ({ commit }, { guestbookid, type, content }) => {
  return getApi({ commit }, apis.replyMsg, { guestbookid, type, content })
    .then((body) => {
      return body.data;
    });
};
// add reply to list
export const addReplyToList = (store, payload) => {
  // payload 留言对象
  store.commit(types.ADD_REPLY_TO_LIST, payload);
};
/**
 * 更新单条消息回复状态
 * @param  {[type]} store   [description]
 * @param  {[type]} payload [description]
 * @return {[type]}         [description]
 */
export const updateMessageRefStatus = (store, { refMsgId }) => {
  store.commit(types.UPDATE_MESSAGE_REF_STATUS, { refMsgId });
};

// 更新查看历史消息状态 1 表示正在查看历史消息，0 表示未查看历史消息
export const lookHistoryMessage = ({ commit }, { status }) => {
  commit(types.LOOK_HISTORY_MESSAGE, { status });
};
export const getMediaId = ({ state }, mediaId) => {
  state.mediaId = mediaId;
};
export const bindUpdateVideo = ({ state }, isUpdateVideo) => {
  state.isUpdateVideo = isUpdateVideo;
};
// 专家答专家端工作日期
export const weeks = ({ state }, weeks) => {
  state.weeks = weeks;
};





// WEBPACK FOOTER //
// ./src/store/expert/actions.expert.js